type TTimeout = (ms: number) => Promise<void>;

const timeout: TTimeout = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

const deepClone = (data: any) => JSON.parse(JSON.stringify(data));

const debounce = (func: (...args: any[]) => any, delay: number) => {
    let timerId: ReturnType<typeof setTimeout>;

    return (...args: any) => {
        clearTimeout(timerId);

        timerId = setTimeout(() => {
            func(...args);
        }, delay);
    };
};

export default {
    timeout,
    deepClone,
    debounce,
};
